export default {
    remains: 'מלאי עדכני',
    download: 'הורדה',
    length: 'אורך',
}
